// import ReactDOM from 'react-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-gray-100 inset-x-0 bottom-0 p-4 z-50 border-t-2 border-gray-700 relative">
      <div className="container mx-auto flex justify-center">
        <h1>Copyright: 2021</h1>
      </div>
    </footer>
  );
}
